module.exports = __webpack_public_path__ + "img/sunrise.e66296fa.jpg";